import { SVGProps, Ref, forwardRef } from 'react';

export const CloudFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M14.5 2a6.5 6.5 0 0 1 6.145 8.614A6 6 0 0 1 18 22H6a6 6 0 0 1-2.941-11.23 5 5 0 0 1 5.905-5.677A6.5 6.5 0 0 1 14.5 2"
            fill="currentColor"
        />
    </svg>
));
CloudFilledSize24Glyph.displayName = 'CloudFilledSize24Glyph';
